import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyBlogSlugs } from "@/data/blogArticles";

export const Route = createFileRoute("/blog/en/$slug")({
  beforeLoad: ({ params }) => {
    const target = legacyBlogSlugs[params.slug] ?? params.slug;
    throw redirect({ to: "/blog/$slug", params: { slug: target }, statusCode: 301 });
  },
});